import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import './Blue_Round_Btn.css'

const Blue_Round_Btn = ({ btnText, onClick , type = "button" }) => {
    return (
        <section className="Blue_Round_Btn_holder" >
            <Button className="Blue_Round_Btn" type={type} onClick={onClick}>{btnText} </Button>
        </section>

    )
}

export default Blue_Round_Btn
